module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ushk-rili_list-wrap"
  }, [(!_vm.datas || !_vm.datas.length) ? _c('li', {
    staticClass: "ushk-rili_list-empty"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.jin10.com/assets/img/sites/rili/empty_holiday.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(!_vm.datas ? '加载中......' : '今日无假期休市安排'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      staticClass: "ushk-rili_list-item"
    }, [_c('div', {
      staticClass: "ushk-rili_list-country"
    }, [_c('img', {
      attrs: {
        "src": ("//www.ushknews.com/img/company/large/" + (data.country) + ".png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-body"
    }, [_c('div', {
      staticClass: "ushk-rili_list-h"
    }, [_c('div', {
      staticClass: "ushk-rili_list-time"
    }, [_c('span', [_vm._v(_vm._s(data.holidayname))])])]), _vm._v(" "), _c('h3', {
      staticClass: "ushk-rili_list-title"
    }, [_vm._v(_vm._s(data.note))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261bb04e","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/MobileContent/HolidayList.vue
// module id = oI9G
// module chunks = 3